import React, { useState, useEffect } from "react";
import CardList from "../../components/PortfolioComponents/CardList";
import { portfolioData } from "../../PortfolioData.js";
import PortfolioTitle from "./PortfolioTitle";

const reverseArray = portfolioData?.reverse();

const Portfolio = () => {
  const [portfolioData, setPortfolioData] = useState([]);

  useEffect(() => {
    setPortfolioData(reverseArray);
  }, [portfolioData]);

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <PortfolioTitle />
      </div>
      {!portfolioData.length ? (
        <h1>Loading</h1>
      ) : (
        <div className="portfolioBody">
          <div className="orderContent">
            <CardList portfolioData={portfolioData} />
          </div>
        </div>
      )}
    </>
  );
};

export default Portfolio;
